import { useTranslation } from "../context/TranslationContext";
import { getProfileAvatarUrl, getProfileInitial } from "../utils/userDisplay";

const idOf = (value) => String(value?._id ?? value ?? "");

/**
 * The group members that match an "@name" being typed, above a chat's message box — like
 * the comment box's list (comments/MentionComposer). Picking one (click, or Enter / Tab on
 * the highlighted one) calls `onPick(member)`.
 */
const MentionSuggestions = ({ people, active, onPick, onHover, isDark, compact = false }) => {
  const { t } = useTranslation();
  if (!people.length) return null;
  const avatarSize = compact ? "h-5 w-5 text-caption-1" : "h-7 w-7 text-caption-1";
  return (
    <ul
      role="listbox"
      aria-label={t("groups.mentionSomeone")}
      className={`absolute bottom-full left-0 right-0 z-50 mb-2 overflow-hidden rounded-radius-sm border py-1 shadow-2xl ${
        "border-separator-default bg-bg-raised"
      }`}
    >
      {people.map((member, i) => {
        const avatarUrl = getProfileAvatarUrl(member);
        return (
          <li key={idOf(member)} role="option" aria-selected={i === active}>
            <button
              type="button"
              // mousedown, not click: the message box must keep focus and the caret.
              onMouseDown={(e) => {
                e.preventDefault();
                onPick(member);
              }}
              onMouseEnter={() => onHover(i)}
              className={`flex w-full items-center gap-2 px-3 text-left ${compact ? "py-1.5 text-footnote" : "py-2 text-subheadline"} ${
                "text-label-primary"
              } ${i === active ? ("bg-fill-tertiary") : ""}`}
            >
              <span className={`inline-flex shrink-0 overflow-hidden rounded-full ${avatarSize}`}>
                {avatarUrl ? (
                  <img src={avatarUrl} alt="" className="h-full w-full object-cover" />
                ) : (
                  <span className={`flex h-full w-full items-center justify-center font-bold ${isDark ? "bg-accent-tinted text-accent-text" : "bg-accent-tinted text-status-success"}`}>
                    {getProfileInitial(member, "?")}
                  </span>
                )}
              </span>
              <span className="min-w-0">
                <span className="block truncate font-semibold">@{member.username}</span>
                {member.businessName && (
                  <span className={`block truncate text-footnote text-label-secondary`}>{member.businessName}</span>
                )}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default MentionSuggestions;
